import $ from 'jquery';
import { initSlider } from '../ui/swiper-helper';

let mapping = {};

/**
 * Add product list items campaign classes.
 * Uses global campaignClassMapping and item data-campaigns attribute
 *
 * @param  {jQuery} $container
 */
export function addCampaignClasses ($container) {

	mapping = window.mapping || {};

	if (!('campaignClass' in mapping)) {
		return;
	}
	$container.find('[data-campaigns]:not(.cclass-added)').each(function () {
		const $item = $(this);
		const ids = String($item.data('campaigns')).split(',');
		let campaignClassAdded = false;
		for (let n = 0; n < ids.length; n++) {
			if (mapping.campaignClass[ids[n]]) {
				$item.addClass('cclass-added ' + mapping.campaignClass[ids[n]]);
				campaignClassAdded = true;
			}
		}
		if (campaignClassAdded) {
			//$item.find('.list-badges').append('<div class="list-badge day-badge">');
		}
	});
}

/**
 * Slick-only pagination renderer. NOT used by this file's own (Swiper) carousel
 * — Swiper renders its own fraction counter. Kept here because the still-Slick
 * PDP image gallery in product-page.js imports it (see INTERCONT-7360, which
 * migrates that gallery and can then remove this).
 */
export function customPagination(event, slick, currentSlide, nextSlide, $carousel) {
	const $customPagination = $carousel.siblings('.custom-pagination').find('.status');
	const i = (currentSlide ? currentSlide : 0) + 1;
	// show pagination based on carousel's scroll position.
	let slidesToScroll = 1;
	if (slick.activeBreakpoint && slick.breakpointSettings && slick.breakpointSettings[slick.activeBreakpoint].slidesToScroll) {
		slidesToScroll = slick.breakpointSettings[slick.activeBreakpoint].slidesToScroll
	}
	const carouselScrollPosition = Math.ceil(i / slidesToScroll);
	const carouselScrollMax = Math.ceil(slick.slideCount / slidesToScroll)
	$customPagination.text(carouselScrollPosition + ' / ' + carouselScrollMax);
}


export function productCarousel(cssClass) {
	$(cssClass).each(function() {
		const carouselEl = this;
		const $carousel = $(carouselEl);
		const label = $carousel.closest('.product-carousel-wrapper').find('h2').first().text().trim() || 'Tuotesuositukset';

		// Nav, counter and scrollbar live in a generated .slider-footer below the
		// slides (swiper-helper.js builds it), matching BS. The CMS still renders
		// the pre-Swiper .custom-pagination bar as a sibling, so hide that
		// leftover markup and opt out of the legacy spacing beneath the carousel,
		// which was tuned for that bar's negative margin-top pull-up.
		$carousel.next('.custom-pagination').hide();
		$carousel.addClass('has-generated-footer');

		const swiper = initSlider(carouselEl, {
			loop: false,
			speed: 300,
			slidesPerView: 2,
			slidesPerGroup: 2,
			centerInsufficientSlides: true,
			navigation: true,
			pagination: { type: 'fraction' },
			scrollbar: true,
			// Matches the original mobileFirst Slick tiers (>=768 -> 2.5, >=1024 -> 3.5, >=1400 -> 4.5).
			breakpoints: {
				768: {
					slidesPerView: 2.5,
					slidesPerGroup: 2
				},
				1024: {
					slidesPerView: 3.5,
					slidesPerGroup: 3
				},
				1400: {
					slidesPerView: 4.5,
					slidesPerGroup: 4
				}
			},
			on: {
				afterInit(swiperInstance) {
					swiperInstance.wrapperEl.setAttribute('aria-label', label);
				}
			}
		});

		let scrolling = false;
		const swipeSensitivity = 15; //bigger value demands bigger swipe
		$carousel.on('mousewheel', (e) => {
			if (e.originalEvent.deltaX !== 0) {
				e.stopPropagation();

				if (!scrolling && Math.abs(e.originalEvent.deltaX) > swipeSensitivity) {
					scrolling = true;
					setTimeout(() => {
						scrolling = false;
					}, 500);

					if (e.originalEvent.deltaX > 0) {
						swiper.slideNext();
					} else {
						swiper.slidePrev();
					}
				}
			}
		});

	});

	addCampaignClasses($('.product-carousel'));
}
